import { useCallback } from 'react';
import type { ExportPeriodParams, UserRoleName } from '@acs/shared';
import { loadExportClient } from '@/lib/export-client';

export function useExportPrograms(roles: UserRoleName[]) {
  const hasExportAllAccess = roles.includes('export') || roles.includes('admin');

  const exportMyData = useCallback(async (params?: ExportPeriodParams) => {
    const apiClient = await loadExportClient();
    await apiClient.exportMyData(params);
  }, []);

  const exportAllData = useCallback(async (params?: ExportPeriodParams) => {
    const apiClient = await loadExportClient();
    await apiClient.exportAllData(params);
  }, []);

  return { hasExportAllAccess, exportMyData, exportAllData };
}
